{
  "origin": "https://ambassadors.yachtapp.net",
  "siteName": "YachtApp Ambassadors",
  "imagePath": "/assets/ambassadors-social-preview.png",
  "imageAlt": "YachtApp Ambassador Program — Share YachtApp. Earn referral commissions.",
  "imageWidth": 1200,
  "imageHeight": 630
}
